<rt-message
  *ngIf="selectedCount > currentViewSelectedCount"
  variant="context-information small"
  [attr.margin-bottom]="hasBottomMargin || null"
  [attr.margin-top-medium]="hasTopMarginMedium || null"
>
  <div class="text">
    <ng-container *ngIf="currentViewSelectedCount > 0">
      <div
        [innerHTML]="
          'rtu.common.bulk_select.messages.out_of_view_with_current'
            | translate : { totalCount: selectedCount, visibleCount: currentViewSelectedCount }
        "
      ></div>
    </ng-container>
    <ng-container *ngIf="currentViewSelectedCount === 0">
      <div
        [innerHTML]="
          'rtu.common.bulk_select.messages.out_of_view' | translate : { totalCount: selectedCount }
        "
      ></div>
    </ng-container>
  </div>
  <rt-button variant="plain" (click)="clearSelection.emit()">
    {{ 'rtu.common.bulk_select.messages.unselect_all' | translate }}
  </rt-button>
</rt-message>
